module.exports = "/packs/images/homepage/activity/swimming_mobile~da4fc3c85b0dc55fbafa15c073acb82b.jpg";